import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

export type PatientCreationInfo = {
  givenName: string;
  familyName: string;
  email: string;
  phone: string;
};

export const patientCreationInfoSchema: Schema<PatientCreationInfo> = z.object({
  givenName: z.string('form.required').check(z.minLength(1)),
  familyName: z.string('form.required').check(z.minLength(1)),
  email: z.email('form.email.invalid'),
  phone: cz.phone({ string: 'form.required', refine: 'form.phone.invalid' }),
});

export const partialPatientCreationInfoSchema: Schema<
  Partial<PatientCreationInfo>
> = z.object({
  givenName: z.optional(z.string()),
  familyName: z.optional(z.string()),
  email: z.optional(z.string()),
  phone: z.optional(cz.phone()),
});
